import{SymbolLogo}from'common/components/SymbolLogo/SymbolLogo';export default SymbolLogo;